import RouteView from "../../navigation/RouteView";
import BriefEditorPage from "./BriefEditorPage";
import { briefEditorRoute } from "./navigation";

export default function BriefEditorNavigator() {
    return <RouteView route={briefEditorRoute} component={BriefEditorPage} />;
}
